import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../../consts';

const Calculator = () => {
    const [cost, setCost] = useState(0);
    const [time, setTime] = useState(0);
    
    const delivery_type_translater = {
        "1": "auto",
        "2": "avia",
        "3": "ship",
    };

    const cargo_type_translater = {
        'Одежда': "clothes",
        'Обувь': "shoes",
        'Товары народного потребления': "consumer",
        'Автозапчасти': "autoparts",
        'Хоз товары': "household",
    };

    const [selectedCountries, setSelectedCountries] = useState(['Китай', 'Россия']);
    const [selectedCities, setSelectedCities] = useState(['Гуанчжоу', 'Москва']);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [showAllCities, setShowAllCities] = useState([false, false]); 

    const countries = ['Китай', 'Россия'];
    const cities = {
        'Китай': ['Гуанчжоу'],
        'Россия': ['Москва'],
    };

    useEffect(() => {
        const savedCities = localStorage.getItem('selectedCities');
        if (savedCities) {
            setSelectedCities(JSON.parse(savedCities));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('selectedCities', JSON.stringify(selectedCities));
    }, [selectedCities]);

    const toggleDropdown = (index) => {
        setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    };

    const selectCountry = (country, index) => {
        const newCountries = [...selectedCountries];
        newCountries[index] = country; 
        setSelectedCountries(newCountries);
        setSelectedCities((prevCities) => {
            const newCities = [...prevCities];
            newCities[index] = ''; 
            return newCities;
        });
        setShowAllCities((prev) => {
            const newState = [...prev];
            newState[index] = false; 
            return newState;
        });
    };

    const selectCity = (city, index) => {
        const newCities = [...selectedCities];
        newCities[index] = city; 
        setSelectedCities(newCities);
        setOpenDropdownIndex(null); 
    };

    const swapCountries = () => {
        setSelectedCountries([selectedCountries[1], selectedCountries[0]]);
        setSelectedCities([selectedCities[1], selectedCities[0]]);
    };

    const [activeButton, setActiveButton] = useState(0); 
    const [hoveredButton, setHoveredButton] = useState(null); 

    const buttons = [
        { label: 'Авто', greyImg: "/img/calkulator/carGrey.svg", activeImg: "/img/calkulator/carActive.svg" },
        { label: 'Авиа', greyImg: "/img/calkulator/samoletikGrey.svg", activeImg: "/img/calkulator/samoletikActive.svg" },
        { label: 'Морем', greyImg: "/img/calkulator/corablickGrey.svg", activeImg: "/img/calkulator/corablickActive.svg" },
    ];

    const [weight, setWeight] = useState('');
    const [volume, setVolume] = useState('');
    const regex = /^(\d+([.,]?\d{0,2})?)?$/;

    const handleWeightChange = (increment) => {
        const newValue = parseFloat(weight.replace(',', '.')) || 0; 
        const updatedValue = newValue + increment;

        if (updatedValue >= 0) { 
            setWeight(updatedValue.toFixed(2).toString().replace(',', '.')); 
        }
    };
    
    const handleWeightInputChange = (e) => {
        const inputValue = e.target.value;
        if (regex.test(inputValue)) {
            setWeight(inputValue); 
        }
    };

    const handleVolumeInputChange = (e) => {
        const inputValue = e.target.value;
        if (regex.test(inputValue)) {
            setVolume(inputValue); 
        }
    };

    const handleVolumeChange = (increment) => {
        const newValue = parseFloat(volume.replace(',', '.')) || 0;
        const updatedValue = newValue + increment;

        if (updatedValue >= 0) {
            setVolume(updatedValue.toFixed(2).toString().replace(',', '.'));
        }
    };

    // Поля с выбором типа груза
    const [isOpen, setIsOpen] = useState(false);
    const [selectedType, setSelectedType] = useState('');

    const cargoTypes = [
        'Одежда',
        'Обувь',
        'Товары народного потребления',
        'Автозапчасти',
        'Хоз товары',
    ];

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleSelectType = (type) => {
        setSelectedType(type);
        setIsOpen(false);
    };

    const handleReset = () => {
        setSelectedType('');
        setIsOpen(false);
    };


    const calculateDefaults = (deliveryType) => {
        switch (deliveryType) {
            case "auto":
                setCost('1.5'); 
                setTime('10-15'); 
                break;
            case "avia":
                setCost('35'); 
                setTime('1-7'); 
                break;
            case "ship":
                setCost('1'); 
                setTime('30'); 
                break;
            default:
                setCost(0);
                setTime(0);
                break;
        }
    };





    const Calculate = async (delivery, cargo, w, v) => {
        console.log({
            "volume": v,
            "weight": w,
            "cargo_type": cargo,
            "delivery_type": delivery
        });

        setCost("-");
        setTime("-");

        try {
            const response = await fetch(`${BACKEND_URL}/api/v1/calculator/precalculate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "volume": v,
                    "weight": w,
                    "cargo_type": cargo,
                    "delivery_type": delivery
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const fetchData = await response.json();
            setCost(fetchData.price);
            setTime(fetchData.display_time);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if ((activeButton + 1) && selectedType && weight && volume) {
            const deliveryType = delivery_type_translater[`${activeButton + 1}`];
            Calculate(deliveryType, cargo_type_translater[selectedType], weight, volume);
        } else if (activeButton >= 0) { // Проверяем, был ли выбран тип доставки
            calculateDefaults(delivery_type_translater[`${activeButton + 1}`]);
        }
    }, [activeButton, selectedType, weight, volume]); // Зависимости для useEffect

    const GoToCalcPage = () => {
        localStorage.setItem("weight", weight);
        localStorage.setItem("volume", volume);
        localStorage.setItem("delivery_type", delivery_type_translater[`${activeButton + 1}`]);
        localStorage.setItem("cargo_type", selectedType);

        console.log(localStorage.getItem('weight'));
        window.location.replace('/calculator');
    };

    return(
        <div className="w-full lg:w-[514px]">

            {/* ВЕРХ */}
            <div className="rounded-[16px] bg-[#fff] flex items-center w-full p-[16px] sm:p-[30px] gap-[12px] mb-[10px]">
                <div className='flex flex-col items-center'>
                    <img src="/img/calkulator/otkuda.svg" />
                    <img src="/img/calkulator/punktir.svg" />
                    <img src="/img/calkulator/kuda.svg" />
                </div>
                <div className="w-full">
                    {/* Откуда нада */}
                    <button onClick={() => toggleDropdown(0)} className="w-full flex items-center justify-between">
                        <div>{selectedCities[0] || 'Выберите город'}</div>
                        <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M15.5887 8.08867L9.99941 13.6779L4.41016 8.08867L5.58867 6.91016L9.99941 11.3209L14.4102 6.91016L15.5887 8.08867Z" fill="#626C75"/>
                            </svg>
                        </div>
                    </button>

                    {/* Выпадающий список для первой страны */}
                    {openDropdownIndex === 0 && (
                        <div className="absolute right-[30px] sm:right-[60px]  w-[270px] sm:w-[444px] bg-white border rounded-[26px] border-gray-300 shadow-lg z-30 p-[26px]">
                            <div className='flex justify-between'>
                                <div className='flex items-center gap-[5px]'>
                                    <img src="/img/calkulator/otkuda.svg" />
                                    <span>Откуда</span>
                                </div>
                                <button onClick={() => setOpenDropdownIndex(null)}>
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M16.1793 5.50078L15.0008 4.32227L10.0008 9.32227L5.00078 4.32227L3.82227 5.50078L8.82227 10.5008L3.82227 15.5008L5.00078 16.6793L10.0008 11.6793L15.0008 16.6793L16.1793 15.5008L11.1793 10.5008L16.1793 5.50078Z" fill="#626C75"/>
                                    </svg>
                                </button>
                            </div>
                            <div className='filters my-[20px] flex gap-[5px] flex-wrap'>
                                <button
                                    onClick={() => selectCountry('Все', 0)}
                                    className={`text-[14px] text-[#626C75] rounded-[50px] py-[4px] px-[8px] border-[#C9CED2] border-solid border-[1px] ${selectedCountries[0] === 'Все' ? 'bg-[#1F2225] text-[#fff]' : 'bg-[#fff]'} hover:bg-[#1F2225] hover:text-[#fff] duration-200`}>
                                    Все
                                </button>
                                {countries.map((country) => (
                                    <button
                                        key={country}
                                        onClick={() => selectCountry(country, 0)}
                                        className={`text-[14px] text-[#626C75] rounded-[50px] py-[4px] px-[8px] border-[#C9CED2] border-solid border-[1px] ${selectedCountries[0] === country ? 'bg-[#1F2225] text-[#fff]' : 'bg-[#fff]'} hover:bg-[#1F2225] hover:text-[#fff] duration-200`}>
                                        {country}
                                    </button>
                                ))}
                            </div>
                            <div className='cities overflow-y-auto h-[200px] custom-scroll'>
                                {(showAllCities[0] || selectedCountries[0] === 'Все' ? Object.values(cities).flat() : cities[selectedCountries[0]] || []).map((city) => (
                                    <div key={city} onClick={() => selectCity(city, 0)} className="p-2 hover:bg-gray-200 cursor-pointer">
                                        {city}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Кнопка для смены стран */}
                    <div className="flex items-center justify-center relative">
                        <div className="absolute inset-x-0 border-solid border-[1px] border-[#E4E6E9]"></div>
                        <button onClick={swapCountries} className="bg-[#fff] group hover:bg-[#C3372E] transition-colors rounded-full border-solid border-[1px] border-[#C9CED2] ml-[60%] rounded-[100px] p-[5px] z-10 flex items-center">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className='fill-[#1F2225] transition-colors group-hover:fill-[#fff]'>
                                <path d="M12.7587 8.01536L7.99949 2.46289L3.24023 8.01536L4.75875 9.31694L6.99949 6.70274L6.99949 20.9995H8.99949L8.99949 6.70274L11.2402 9.31694L12.7587 8.01536Z" />
                                <path d="M21.7587 15.9836L16.9995 21.5361L12.2402 15.9836L13.7587 14.682L15.9995 17.2962L15.9995 2.99948L17.9995 2.99948L17.9995 17.2962L20.2402 14.682L21.7587 15.9836Z" />
                            </svg>
                        </button>
                    </div>

                    {/* Куда нада */}
                    <button onClick={() => toggleDropdown(1)} className="w-full flex items-center justify-between">
                        <div>{selectedCities[1] || 'Выберите город'}</div>
                        <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M15.5887 8.08867L9.99941 13.6779L4.41016 8.08867L5.58867 6.91016L9.99941 11.3209L14.4102 6.91016L15.5887 8.08867Z" fill="#626C75"/>
                            </svg>
                        </div>
                    </button>

                    {/* Выпадающий список для второй страны */}
                    {openDropdownIndex === 1 && (
                        <div className="absolute bg-white border border-gray-300 mt-[-50px] right-[30px] sm:right-[60px]  w-[270px] sm:w-[444px] rounded-[26px] shadow-lg z-30 p-[26px]">
                            <div className='flex justify-between'>
                                <div className='flex items-center gap-[5px]'>
                                    <img src="/img/calkulator/kuda.svg" />
                                    <span>Куда</span>
                                </div>
                                <button onClick={() => setOpenDropdownIndex(null)}>
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M16.1793 5.50078L15.0008 4.32227L10.0008 9.32227L5.00078 4.32227L3.82227 5.50078L8.82227 10.5008L3.82227 15.5008L5.00078 16.6793L10.0008 11.6793L15.0008 16.6793L16.1793 15.5008L11.1793 10.5008L16.1793 5.50078Z" fill="#626C75"/>
                                    </svg>
                                </button>
                            </div>
                            <div className='filters my-[20px] flex gap-[5px] flex-wrap'>
                                <button
                                    onClick={() => selectCountry('Все', 1)}
                                    className={`text-[14px] text-[#626C75] rounded-[50px] py-[4px] px-[8px] border-[#C9CED2] border-solid border-[1px] ${selectedCountries[1] === 'Все' ? 'bg-[#1F2225] text-[#fff]' : 'bg-[#fff]'} hover:bg-[#1F2225] hover:text-[#fff] duration-200`}>
                                    Все
                                </button>
                                {countries.map((country) => (
                                    <button
                                        key={country}
                                        onClick={() => selectCountry(country, 1)}
                                        className={`text-[14px] text-[#626C75] rounded-[50px] py-[4px] px-[8px] border-[#C9CED2] border-solid border-[1px] ${selectedCountries[1] === country ? 'bg-[#1F2225] text-[#fff]' : 'bg-[#fff]'} hover:bg-[#1F2225] hover:text-[#fff] duration-200`}>
                                        {country}
                                    </button>
                                ))}
                            </div>
                            <div className='cities overflow-y-auto h-[200px] custom-scroll'>
                                {(showAllCities[1] || selectedCountries[1] === 'Все' ? Object.values(cities).flat() : cities[selectedCountries[1]] || []).map((city) => (
                                    <div key={city} onClick={() => selectCity(city, 1)} className="p-2 hover:bg-gray-200 cursor-pointer">
                                        {city}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
        </div>




            {/* КАКУЛЯТОР */}
            <div className='rounded-[16px] bg-[#fff] w-full p-[16px] sm:p-[30px]'>
                <div className='flex items-center flex-wrap gap-[8px]'>
                    {buttons.map((button, index) => (
                        <div key={index} className="relative">
                            <input
                                type="radio"
                                id={`button-${index}`}
                                name="transport"
                                value={index}
                                checked={activeButton === index}
                                onChange={() => setActiveButton(index)}
                                className="absolute opacity-0" 
                            />
                            <label
                                htmlFor={`button-${index}`}
                                className={`cursor-pointer border border-solid border-1px border-[#C9CED2] rounded-[50px] flex items-center gap-[4px] py-[6px] px-[12px] text-[14px] sm:text-[16px]
                                ${activeButton === index ? 'bg-[#1F2225] text-white' : 'bg-[#fff] text-[#C9CED2]'}
                                hover:bg-[#1F2225] hover:text-white transition duration-200`}
                                onMouseEnter={() => setHoveredButton(index)}
                                onMouseLeave={() => setHoveredButton(null)}
                            >
                                <img 
                                    src={hoveredButton === index || activeButton === index ? button.activeImg : button.greyImg} 
                                    alt={button.label} 
                                />
                                {button.label}
                            </label>
                        </div>
                    ))}
                </div>

                <div>
                    <div className='mt-[24px] flex items-center gap-[5px] flex-wrap justify-between'>
                        <div className='flex items-center justify-between w-full sm:w-[49%] border-[1px] border-solid border-[#C9CED2] rounded-[16px]'>
                            <div className='p-[11px] sm:p-[15px]'>
                            <div className='flex items-center justify-between text-[14px] text-[#626C75]'>
                                <span>Вес</span>
                                <span>кг.</span>
                            </div>
                            <div>
                                <input
                                className='w-full text-[#1F2225] outline-none'
                                value={weight}
                                onChange={handleWeightInputChange} 
                                placeholder='0'
                                />
                            </div>
                            </div>
                            <div className='flex flex-col gap-[4px] border-[#C9CED2] border-solid border-l-[1px] py-[6px] sm:py-[9px] px-[8px] sm:px-[12px]'>
                            <button
                                className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                onClick={() => handleWeightChange(0.01)} >
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4721 10.028L8.0007 5.55664L3.5293 10.028L4.47211 10.9709L8.0007 7.44226L11.5293 10.9709L12.4721 10.028Z" fill="white"/>
                                </svg>
                            </button>
                            <button
                                className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                onClick={() => handleWeightChange(-0.01)}>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4721 6.97195L8.0007 11.4434L3.5293 6.97195L4.47211 6.02915L8.0007 9.55774L11.5293 6.02915L12.4721 6.97195Z" fill="white"/>
                                </svg>
                            </button>
                            </div>
                        </div>

                        <div className='flex items-center justify-between w-full sm:w-[49%] border-[1px] border-solid border-[#C9CED2] rounded-[16px]'>
                            <div className='p-[11px] sm:p-[15px]'>
                            <div className='flex items-center justify-between text-[14px] text-[#626C75]'>
                                <span>Объём</span>
                                <span>Куб.м</span>
                            </div>
                            <div>
                                <input
                                className='w-full text-[#1F2225] outline-none'
                                value={volume}
                                onChange={handleVolumeInputChange}
                                placeholder='0'
                                 />
                            </div>
                            </div>
                            <div className='flex flex-col gap-[4px] border-[#C9CED2] border-solid border-l-[1px] py-[6px] sm:py-[9px] px-[8px] sm:px-[12px]'>
                            <button
                                className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                onClick={() => handleVolumeChange(0.01)}>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4721 10.028L8.0007 5.55664L3.5293 10.028L4.47211 10.9709L8.0007 7.44226L11.5293 10.9709L12.4721 10.028Z" fill="white"/>
                                </svg>
                            </button>
                            <button
                                className='bg-[#1F2225] rounded-[50px] p-[4px] hover:bg-red-500 transition duration-200'
                                onClick={() => handleVolumeChange(-0.01)}>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4721 6.97195L8.0007 11.4434L3.5293 6.97195L4.47211 6.02915L8.0007 9.55774L11.5293 6.02915L12.4721 6.97195Z" fill="white"/>
                                </svg>
                            </button>
                            </div>
                        </div>
                    </div>



                    <div className='p-[12px] sm:py-[15px] sm:px-[20px] border-[1px] border-solid border-[#C9CED2] rounded-[16px] w-full mt-[10px]'>
            {!selectedType ? (
                <>
                    <a className='w-full cursor-pointer' onClick={handleToggle}>
                        <div className='flex justify-between items-center'>
                            <div className='text-[#626C75]'>
                                <div className='text-[14px]'>Тип груза</div>
                                <div className='text-[18px] sm:text-[20px]'>Выберите из списка</div>
                            </div>
                            <div>
                                <svg
                                    width="20"
                                    height="21"
                                    viewBox="0 0 20 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                                >
                                    <path d="M15.5887 8.58867L9.99941 14.1779L4.41016 8.58867L5.58867 7.41016L9.99941 11.8209L14.4102 7.41016L15.5887 8.58867Z" fill="#626C75" />
                                </svg>
                            </div>
                        </div>
                    </a>
                    <div className={`flex items-center flex-wrap gap-[8px] transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 mt-[16px]' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                        {cargoTypes.map((type, index) => (
                            <div key={type} className="relative my-[10px]">
                                <input
                                    type="radio"
                                    id={`cargo-type-${index}`}
                                    name="cargoType"
                                    value={type}
                                    checked={selectedType === type}
                                    onChange={() => handleSelectType(type)}
                                    className="absolute opacity-0"
                                />
                                <label
                                    htmlFor={`cargo-type-${index}`}
                                    className='py-[6px] px-[13px] text-[#1F2225] bg-[#EFF0F2] text-[14px] rounded-[50px] cursor-pointer hover:text-[#fff] hover:bg-[#1F2225] duration-200'
                                >
                                    {type}
                                </label>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <div className='flex justify-between items-center'>
                    <div className='text-[#626C75]'>
                        <div className='text-[14px] text-[#fff] bg-[#1F2225] rounded-[50px] py-[6px] px-[12px]'>{selectedType}</div>
                    </div>
                    <button onClick={handleReset}>
                        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.1793 11.4992L12.0008 12.6777L7.00078 7.67773L2.00078 12.6777L0.822266 11.4992L5.82227 6.49922L0.822266 1.49922L2.00078 0.320712L7.00078 5.32071L12.0008 0.320712L13.1793 1.49922L8.17929 6.49922L13.1793 11.4992Z" fill="#1F2225"/>
                        </svg>
                    </button>
                </div>
            )}
        </div>


                    <div className='mt-[24px] flex justify-between items-center'>
                        <div>
                            <div className='text-[#626C75] text-[14px] mb-[12px]'>Сроки доставки</div>
                            <div className='text-[#626C75] text-[20px]'><span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>{time}</span> дн.</div>
                        </div>
                        <div>
                            <div className='text-[#626C75] text-[14px] mb-[12px]'>Стоимость</div>
                            <div className='text-[#626C75] text-[20px]'>от <span className='text-[#1F2225] text-[28px] sm:text-[40px] font-medium'>${cost}</span></div>
                        </div>
                    </div>

                    <div className='mt-[24px]'>
                    <button 
        onClick={() => GoToCalcPage(weight, volume, activeButton, selectedType, delivery_type_translater, cargo_type_translater)} 
        className='w-full bg-[#C3372E] text-[#fff] text-[16px] sm:text-[20px] font-medium flex justify-between items-center py-[14px] px-[20px] sm:py-[20px] sm:px-[32px] rounded-[65px] hover:bg-[#E0473F] duration-200'
    >
        Продолжить расчёт
        <img src="/img/calkulator/strelkaBtn.svg" alt="Стрелка" />
    </button>
                    </div>
                    



                </div>







            </div>
        </div>
    )
}

export default Calculator
